"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-gradient-elements.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function BackgroundGradientElements() {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: "absolute top-0 right-0 w-1/3 h-1/3 \
bg-gradient-to-br from-blue-4/30 to-violet-4/40 dark:from-indigo-12/20 dark:to-v\
iolet-12/30 rounded-bl-[100px]" }),
    /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 left-0 w-1/2 h-1/\
2 bg-gradient-to-tr from-indigo-3/40 to-cyan-3/30 dark:from-blue-12/30 dark:to-c\
yan-12/20 rounded-tr-[200px]" })
  ] });
}
__name(BackgroundGradientElements, "BackgroundGradientElements");
export {
  BackgroundGradientElements
};
